// @flow
import React from 'react'
import { View } from 'react-native'

type Props = {
  width?: number | string,
  height?: number | string,
  alignHorizontal?: 'flex-start'
    | 'flex-end'
    | 'center'
    | 'space-between'
    | 'space-around'
    | 'space-evenly',
  alignVertical?: 'flex-start' | 'flex-end' | 'center' | 'stretch' | 'baseline',
  style?: Object,
  children: Object,
}
const Row = ({
  width,
  height,
  alignHorizontal,
  alignVertical,
  style,
  children,
}: Props) => {
  return (
    <View
      style={[
        {
          flexDirection: 'row',
          width: width || '100%',
          height,
          alignItems: alignVertical || 'center',
          justifyContent: alignHorizontal || 'flex-start',
        },
        style,
      ]}>
      {children}
    </View>
  )
}
export default Row
